/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./bounce-dot.vue.js?vue&type=template&id=fe49d862!=!../../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./bounce-dot.vue?vue&type=template&id=fe49d862"
import script from "./bounce-dot.vue.ts?vue&type=script&lang=ts!=!../../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./bounce-dot.vue?vue&type=script&lang=ts"
export * from "./bounce-dot.vue.ts?vue&type=script&lang=ts!=!../../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./bounce-dot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports